/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_ac_unit } from './places/ac_unit.icon';
import { icon_airport_shuttle } from './places/airport_shuttle.icon';
import { icon_all_inclusive } from './places/all_inclusive.icon';
import { icon_beach_access } from './places/beach_access.icon';
import { icon_business_center } from './places/business_center.icon';
import { icon_child_care } from './places/child_care.icon';
import { icon_free_breakfast } from './places/free_breakfast.icon';
import { icon_casino } from './places/casino.icon';
import { icon_child_friendly } from './places/child_friendly.icon';
import { icon_fitness_center } from './places/fitness_center.icon';
import { icon_golf_course } from './places/golf_course.icon';
import { icon_hot_tub } from './places/hot_tub.icon';
import { icon_kitchen } from './places/kitchen.icon';
import { icon_pool } from './places/pool.icon';
import { icon_room_service } from './places/room_service.icon';
import { icon_smoke_free } from './places/smoke_free.icon';
import { icon_rv_hookup } from './places/rv_hookup.icon';
import { icon_spa } from './places/spa.icon';
import { icon_smoking_rooms } from './places/smoking_rooms.icon';
var icons = {
  "ac_unit" : icon_ac_unit,
"airport_shuttle" : icon_airport_shuttle,
"all_inclusive" : icon_all_inclusive,
"beach_access" : icon_beach_access,
"business_center" : icon_business_center,
"child_care" : icon_child_care,
"free_breakfast" : icon_free_breakfast,
"casino" : icon_casino,
"child_friendly" : icon_child_friendly,
"fitness_center" : icon_fitness_center,
"golf_course" : icon_golf_course,
"hot_tub" : icon_hot_tub,
"kitchen" : icon_kitchen,
"pool" : icon_pool,
"room_service" : icon_room_service,
"smoke_free" : icon_smoke_free,
"rv_hookup" : icon_rv_hookup,
"spa" : icon_spa,
"smoking_rooms" : icon_smoking_rooms,
};
export { icons };
